import React from 'react'
import { cn } from '../../utils/cn'

const FILLS = {
  accent: 'bg-accent-500',
  gain:   'bg-gain-500',
  loss:   'bg-loss-500',
  ink:    'bg-ink-800',
  amber:  'bg-amber-500',
}

/**
 * Meter — a slim, premium progress bar (capital headroom, win-rate, allocation).
 *   <Meter value={0.62} tone="accent" label="Capital deployed" right="₹39L / ₹63L" />
 * `value` is 0..1. Optional `markers` are 0..1 positions for thresholds (e.g. the cap).
 */
export default function Meter({ value = 0, tone = 'accent', label, right, markers = [], size = 'md', className }) {
  const pct = Math.max(0, Math.min(1, Number(value) || 0)) * 100
  const h = size === 'sm' ? 'h-1.5' : size === 'lg' ? 'h-3' : 'h-2'
  return (
    <div className={className}>
      {(label || right) && (
        <div className="flex items-baseline justify-between mb-1.5">
          {label && <span className="text-xs font-medium text-ink-500">{label}</span>}
          {right && <span className="text-xs font-semibold text-ink-700 tabular-nums">{right}</span>}
        </div>
      )}
      <div className={cn('relative w-full rounded-full bg-ink-100 overflow-hidden', h)}>
        <div
          className={cn('h-full rounded-full transition-[width] duration-700 ease-out-quint', FILLS[tone] || FILLS.accent)}
          style={{ width: `${pct}%` }}
        />
        {markers.map((m, i) => (
          <span
            key={i}
            className="absolute top-0 bottom-0 w-px bg-ink-400/60"
            style={{ left: `${Math.max(0, Math.min(1, m)) * 100}%` }}
          />
        ))}
      </div>
    </div>
  )
}
